import { render, staticRenderFns } from "./RegistrationPrice.vue?vue&type=template&id=0a49e64e&scoped=true&"
import script from "./RegistrationPrice.vue?vue&type=script&lang=js&"
export * from "./RegistrationPrice.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPrice.vue?vue&type=style&index=0&id=0a49e64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a49e64e",
  null
  
)

export default component.exports